export default {
  left: 'ArrowLeft',
  up: 'ArrowUp',
  right: 'ArrowRight',
  down: 'ArrowDown',
  x: 'KeyX',
  z: 'KeyZ',
};
